import type { ShopItemType } from '@sorare/core/src/__generated__/globalTypes';
import type { FilterableType } from '@sorare/core/src/types/shopItems';
import {
  MERCHANDISE_TYPE,
  MERCHANDISE_TYPES,
} from '@sorare/core/src/types/shopItems';

export const getFilterableTypes = (types: ShopItemType[]) => {
  return types.reduce((acc, type) => {
    const isMerchandiseType = MERCHANDISE_TYPES.includes(
      type as (typeof MERCHANDISE_TYPES)[number]
    );
    if (isMerchandiseType) {
      return acc.includes(MERCHANDISE_TYPE) ? acc : [...acc, MERCHANDISE_TYPE];
    }
    return [...acc, type as FilterableType];
  }, [] as FilterableType[]);
};
